var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2725_9727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9891 14.593V12.993C19.9891 12.5686 19.8205 12.1617 19.5204 11.8616C19.2204 11.5615 18.8134 11.393 18.3891 11.393H2.38906C1.96472 11.393 1.55775 11.5615 1.25769 11.8616C0.957633 12.1617 0.789063 12.5686 0.789062 12.993V22.593C0.789063 23.0173 0.957633 23.4243 1.25769 23.7243C1.55775 24.0244 1.96472 24.193 2.38906 24.193H18.3891C18.8134 24.193 19.2204 24.0244 19.5204 23.7243C19.8205 23.4243 19.9891 23.0173 19.9891 22.593V20.993M19.9891 14.593H13.5891C12.7404 14.593 11.9264 14.9301 11.3263 15.5302C10.7262 16.1303 10.3891 16.9443 10.3891 17.793C10.3891 18.6417 10.7262 19.4556 11.3263 20.0557C11.9264 20.6558 12.7404 20.993 13.5891 20.993H19.9891M19.9891 14.593C20.8378 14.593 21.6517 14.9301 22.2518 15.5302C22.8519 16.1303 23.1891 16.9443 23.1891 17.793C23.1891 18.6417 22.8519 19.4556 22.2518 20.0557C21.6517 20.6558 20.8378 20.993 19.9891 20.993M5.58906 11.393V6.59297C5.58906 5.31993 6.09477 4.09903 6.99495 3.19886C7.89512 2.29868 9.11602 1.79297 10.3891 1.79297C11.6621 1.79297 12.883 2.29868 13.7832 3.19886C14.6833 4.09903 15.1891 5.31993 15.1891 6.59297V11.393M19.1891 17.793H20.7891M15.9891 17.793H17.5891M12.7891 17.793H14.3891",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2725_9727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.015625 0.982422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassicon);
export default __webpack_public_path__ + "static/media/passicon.2d304f362cc882736ef35a608b8ced75.svg";
export { ForwardRef as ReactComponent };